import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { ShipmentService } from '../../services/shipment.service';
import { SaleService } from '../../services/sale.service';
import { CarriesService } from '../../services/carriers.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Title } from '@angular/platform-browser';
import { TitleService } from '../../services/title.service';
import { TaxService } from '../../services/tax.service';
import { StateService } from '../../services/state.service';
import { LocationService } from "../../services/location.service";
import { ContactsService } from '../../services/contacts.service';
import { CarrieraccountService } from '../../services/carrieraccount.service';
import { MatTabGroup } from '@angular/material/tabs';
import { Methods } from "../../shared/methods";
import { ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { SelectItemsModalComponent } from '../select-items-modal.component';
import { MatDialog } from '@angular/material/dialog';
import swal from "sweetalert2";

declare var $: any;

@Component({
  selector: 'app-new-shipment',
  templateUrl: './new-shipment.component.html',
  styleUrls: ['./new-shipment.component.css'],
  providers: [ UserService ]
})
export class NewShipmentComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('freightCheckbox') freightCheckbox!: MatCheckbox;
  @ViewChild('tabs') tabs!: MatTabGroup;
  public mtds: Methods = new Methods();
  public identity;
  public shipmentsUnderSo = [];
  public soId: string | null = null;
  public soNumber:any = null;
  public searchso:any = '';
  public searching: boolean = false;
  public loadingShipments: boolean = false;
  public codLocked = true;
  public options: Array<any> = [];

  public shipmentItems: any[] = [];
  public selectedIds: Set<number> = new Set<number>();
  idShipmentExternal : string | null = null;
  private dtInstance: any = null;
  private dtInited = false;
  public loadingShipmentItems: boolean = false;
  public token;

  public shownewshipmentform: boolean =false;
  public shipmentSelected: boolean = false;
  public saveLoading: boolean = false;

  public loadingStates = false;
  public loadingStates2 = false;
  public states: any[] = [];
  public states2: any[] = [];

  public dataFromExternal: boolean = false;

  public shipfromcountry:any = '';
  public shiptocountry:any = '';

  public hqdata:any = '';
  public hqdataTo:any = '';

  public minDate: Date;

  public userLogged: any = null;
  public clientCompanyId: any = null;
  public repCompanyId: any = null;

  public userLocations: Array<any> = [];
  public locations: Array<any> = [];

  public userCompanyId: any = null;

  public isNew: boolean = false;
  
  public shipmentsPage: number = 1;
  public shipmentsPerPage: string = '10';
  public shipmentsTotalItemsCount: number = 0;
  public shipmentsTotalPages: number = 1;
  public shipmentsSortColumn: string = '';
  public shipmentsSortState: string = '';
  private latestShipmentsRequestId = 0;
  public shipmentsScheduler: DinamicData = new DinamicData(
    [
 
      'Shipment ID',
      'Tracking Number',
      'Carrier',
      'Service Type',
      'Scheduled Ship Date',
      'Shipped',
      'Ship Date',
      'Status',
      'Ship From',
      'Ship To',
      'Actions'
    ]
  )

  public filtros = [

   { key: 'shipment_id', title: 'Shipment ID', value: '', type: 'equalto', key_type: 'shipment_id_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
    ] },
    { key: 'tracking_number', title: 'Tracking Number', value: '', type: 'contains', key_type: 'tracking_number_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    
    { key: 'carrier', title: 'Carrier', value: '', type: 'contains', key_type: 'carrier_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    { key: 'service_type', title: 'Service Type', value: '', type: 'contains', key_type: 'service_type_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
     { key: 'scheduled_ship_date', title: 'Scheduled Ship Date', value: '', type: 'equalto', key_type: 'scheduled_ship_date_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
    ] },
    { key: 'shipped', title: 'Shipped', value: '', type: 'contains', key_type: 'shipped_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    { key: 'ship_date', title: 'Ship Date', value: '', type: 'equalto', key_type: 'ship_date_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
    ] },
    { key: 'status', title: 'Status', value: '', type: 'contains', key_type: 'status_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    { key: 'shipfrom', title: 'Ship From', value: '', type: 'contains', key_type: 'shipfrom_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    { key: 'shipto', title: 'Ship To', value: '', type: 'contains', key_type: 'shipto_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] }
  ];

  public contactsShippingTo: any [] = [];
  public contactsShippingFrom: any [] = [];

  public carriersUnified: Array<{
    id: string;     
    name: string; 
    type: string;  
    source: 'internal' | 'external';
    raw?: any;  
    services: Array<{ id: string; code?: string; name: string; service_code?: string; serviceName?: string }>;
  }> = [];


  private _gotInternalCarriers = false;
  private _gotExternalCarriers = false;

  public countries: any[] = [
  ];


  public shipment = {
    id: null,
    so_id: null,
    dateShipment: new Date(),
    carrier: null,
    serviceType: null,
    paymentType: null,
    billAccountNumber: null,
    addFreightInvoice: false,
    cod: '',
    declaredValue: '',
    warehouse: null,
    unitOfMeasurement: '',
    unitDimension: '',
    email: '',
    notifications: {  
      exception: false,
      delivery: false,
      shipment: false,
      shipTo: false
    },
    signature: null,
    fromCompany: '',
    fromName: '',
    fromPhone: '',
    fromAddress: '',
    fromAddress2: '',
    fromCity: '',
    fromState: '',
    fromZip: '',
    fromCountry: '',
    fromEmail: '',
    fromFax: '',
    toCompany: '',
    toName: '',
    toPhone: '',
    toAddress: '',
    toAddress2: '',
    toCity: '',
    toState: '',
    toZip: '',
    toCountry: '',
    toEmail: '',
    toFax: '',
    shipfromlocation_id: 'null',
    shiptolocation_id: 'null',
    items: [],
    status: 'Scheduled',
    type: 'MANUAL',
    blindDropShipWayBill: false,
    saturdayDelivery: false,
    residentDelivery: false,
    serviceString: ''
  }

  public carrierList = [
  ]

  public carrierListExternal: { carriers: any[] } | any[] = { carriers: [] };
  

  public serviceList: Array<{ id: string | number; name: string }> = [];

  public paymentList: Array<{ id: string | number; name: string }> = [];


  public billAccountNumberList: Array<{ id: string; name: string }> = [
      { id: 'manual', name: 'Enter manually' } // opción fija
    ];

  public billAccountNumberSelection: string = 'manual';
  public manualBillAccountNumber: string = '';

   public warehouseList = [
    {"id": 1, "name": "Warehouse uno"},
    {"id": 2, "name": "Warehouse dos"},
  ]

  public unitOfMeasurementList = [
    {"id": 1, "name": "Kgs"},
    {"id": 2, "name": "Lbs"},
  ]

  public unitDimensionList = [
    {"id": 1, "name": "inch"},
    {"id": 2, "name": "centimeter"},
  ]

   public emailList = [
    {"id": 1, "name": "email1@gmail.com"},
    {"id": 2, "name": "email2@gmail.com"},
  ]

  public signatureList = [
    {"id": 1, "name": "No Signature"},
    {"id": 2, "name": "Signature Required"},
    {"id": 2, "name": "Adult Signature Required"}
  ]

  public fromCompanyList = [
    {"id": 1, "name": "Company Name 1"},
    {"id": 2, "name": "Company Name 2"}
  ]

  public fromPhoneList = [
    {"id": 1, "name": "3314657766"},
    {"id": 2, "name": "713452111"}
  ]

  public fromCityList = [
    {"id": 1, "name": "Guadalajara"},
    {"id": 2, "name": "Zapopan"}
  ]

  public fromStateList = [
    {"id": 1, "name": "Jalisco"},
    {"id": 2, "name": "Nuevo Leon"}
  ]

  public fromZipList = [
    {"id": 1, "name": "44660"},
    {"id": 2, "name": "77477"}
  ]

  public fromCountryList = [
    {"id": 1, "name": "United States"},
    {"id": 2, "name": "Mexico"}
  ]

  public toCompanyList = [
    {"id": 1, "name": "Company Name 1"},
    {"id": 2, "name": "Company Name 2"}
  ]

  public toPhoneList = [
    {"id": 1, "name": "3314657766"},
    {"id": 2, "name": "713452111"}
  ]

  public toCityList = [
    {"id": 1, "name": "Guadalajara"},
    {"id": 2, "name": "Zapopan"}
  ]

  public toStateList = [
    {"id": 1, "name": "Jalisco"},
    {"id": 2, "name": "Nuevo Leon"}
  ]

  public toZipList = [
    {"id": 1, "name": "44660"},
    {"id": 2, "name": "77477"}
  ]

  public toCountryList = [
    {"id": 1, "name": "United States"},
    {"id": 2, "name": "Mexico"}
  ]

  constructor(
    private _userService: UserService,
    private _shipmentService: ShipmentService,
    private _config: ConfigService,
    private _route: ActivatedRoute,
    private titleService: Title,
    private titleServices: TitleService,
    private _saleService: SaleService,
    private _taxService: TaxService,
    private _stateService: StateService,
    private _locationService: LocationService,
    private _contactsService: ContactsService,
    private _carriesService: CarriesService,
    private _router: Router,
    private _carrieraccountService: CarrieraccountService,
    private dialog: MatDialog
  ) {
    
    this.titleService.setTitle( 'Shipment Scheduler' );

  }

  /** Parseo seguro de JSON; si falla, devuelve [] o {} según defaultVal */
private safeParse<T = any>(val: any, defaultVal: T): T {
  if (!val && val !== 0) return defaultVal;
  if (Array.isArray(val) || typeof val === 'object') return val as T;
  try {
    return JSON.parse(String(val)) as T;
  } catch {
    return defaultVal;
  }
}

private isExternalCarrier(c: any): boolean {
  return (c?.type === 'EXTERNAL') || !!c?.externalCarrierId || !!c?.externalCarrierCode;
}

openAddItemsModal() {

  

    if (!this.soId) {
      this.showToast('info', 'Please select a Sales Order first', 1500);
      return;
    }

    let me = this;

    this._saleService.availableToShip(this.soId, '').subscribe((r) => {
      const rows = Array.isArray(r?.lineDesglosado) ? r.lineDesglosado : [];
      const modal = this.dialog.open(SelectItemsModalComponent, {
        width: '900px',
        data: { items: rows },
      });

      modal.afterClosed().subscribe((selectedItems) => {
       /* if (Array.isArray(selectedItems) && selectedItems.length) {
          const mapped = selectedItems.map((x: any) => ({
            id: x.id,
            soline: x.soline,
            item: x.item,
            manufacturer: x.manufacturer,
            serialNumber: x.serialNumber,
            description: x.description,
            status: x.status?.trim(),
            receivestatus: x.receivestatus?.trim(),
            shipdate: x.shipdate ? new Date(x.shipdate) : null,
            shipstatus: (x.shipstatus || '').trim(),
          }));
          const idsExistentes = new Set(this.shipmentItems.map(i => i.id));
          const nuevos = mapped.filter(i => !idsExistentes.has(i.id));
          this.shipmentItems.push(...nuevos);
          this.redrawDataTable();

          this.showToast('success', `${nuevos.length} items added`, 2000);
        }*/
        if(selectedItems){


        let jsonsend = {"items": selectedItems};
        this._shipmentService.addItemsToShipment(this.token,this.shipment.id, jsonsend).subscribe((response) => {
          if(response.status == 'success'){
            this.loadingShipmentItems = true;
      
            this._shipmentService.detail(this.token, this.shipment.id).subscribe((r) => {


            if(r.status == "success"){
            
              this.shipment.items= [];
              this.shipmentItems = [];
              
              this.shipmentItems = r.inventories.map((x: any) => ({
              id: x.id,
              soline: x.soline,
              item: x.item,
              manufacturer: x.manufacturer,
              serialNumber: x.serialNumber,
              description: x.description,
              status: x.status?.trim(),
              receivestatus: x.receivestatus?.trim(),
              shipdate: x.shipdate ? new Date(x.shipdate) : null,
              shipstatus: (x.shipstatus || '').trim(),
            }));

         
              
              setTimeout(function(){
                me.redrawDataTable();
                me.loadingShipmentItems = false;
              },2000);



            } 
     
    });

            this.showToast('success', `${selectedItems.length} items added`, 2000);
          } else {
            alert("Error: "+ response?.msg);
          }


        });
      }
      });
    });
  }


 
  ngOnInit() {


    this.identity = this._userService.getIdentity();
    this.token = JSON.parse(localStorage.getItem("token"));
    this.soId = this._route.snapshot.queryParamMap.get('so');
    console.log("this.identity =>", this.identity);


    this.titleServices.setBreadcrumbs([
            { label: "Shipment Scheduler", path: "/shipment-scheduler" },
            { label: "New Shipment" }
          ]);

    this.idShipmentExternal = this._route.snapshot.paramMap.get('idshipmentexternal');
    console.log("this.idShipmentExternal => ", this.idShipmentExternal);

    this.userCompanyId = this.identity.companyId;
  
    const today = new Date();
 
    this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let filtroCarrier = {"filter_status": 1}
    this._carriesService
      .getAccounts(this.userCompanyId, filtroCarrier)
      .subscribe((response2) => {
        this.carrierList = response2.data || [];
        this.buildUnifiedCarriers();
        console.log("carrierList (internos) => ", this.carrierList);
        // Race condition fix: if getShipment resolved before carriers loaded,
        // selectCarrier returned early leaving serviceList empty — re-populate now.
        if (this.shipment.carrier && this.serviceList.length === 0) {
          const carrier = this.carriersUnified.find(c => Number(c.id) === Number(this.shipment.carrier));
          if (carrier) {
            this.serviceList = carrier.services.map(s => ({ id: s.code ? s.code : s.id, name: s.name }));
            this.serviceTypeLoading = false;
          }
        }
      });

    /*this._carriesService
      .showAll(1, "All", 1)
      .subscribe((response2) => {
        this.carrierList = response2.data || [];
        this._gotInternalCarriers = true;
        this.buildUnifiedCarriers();
        console.log("carrierList (internos) => ", this.carrierList);
      });
      */

    // Externos (ShipEngine)
    /*
    Se comenta porque se decidio no mostrarlos realtime
    this._shipmentService
    .listcarriers(this.token)
    .subscribe((response2) => {
      console.log("response2 => ", response2);
      this.carrierListExternal = response2?.carriers ?? { carriers: [] };
      this._gotExternalCarriers = true;
      this.buildUnifiedCarriers();
      console.log("carrierListExternal (SE) => ", this.carrierListExternal);
    });

    entonces se llama directamente this.buildUnifiedCarriers() :
*/

//this.buildUnifiedCarriers();
    

    if(this.soId){
      console.log("SO recibido => ", this.soId);

       this._saleService.getOneSO(this.soId).subscribe((r) => {
      console.log("getOneSOBySO r => ", r.data);

      if(r.status == 'success'){
        if(r.data && r.data.id){
          this.soId = r.data.id;
        
          this.soNumber = r.data.so;
          this.searchso = String(r.data.so || '');

          this.titleServices.setBreadcrumbs([
            { label: `SO# ${this.soNumber}`, path: "/sales-orders/"+ this.soId},
            { label: "Shipment Scheduler", path: "/shipment-scheduler" }
          ]);

          this._locationService
             .getLocationsByUser(this.token, r.data.contactcontactuser_id)
              .subscribe((response2) => {
               this.locations = response2.data;
             });

          if(r.data.shipFromLocationId == -1)
            this.shipment.shipfromlocation_id ="other";
          else if(r.data.shipFromLocationId == 0)
            this.shipment.shipfromlocation_id ="headq";
          else
            this.shipment.shipfromlocation_id = r.data.shipFromLocationId;


          if(r.data.shipToLocationId == -1)
            this.shipment.shiptolocation_id ="other"; 
          else if(r.data.shipToLocationId == 0)
            this.shipment.shiptolocation_id ="headq";
          else
            this.shipment.shiptolocation_id = r.data.shipToLocationId;

          this.shipfromcountry = this.capitalizeWords(r.data.shipfromcountry);
          this.shiptocountry = this.capitalizeWords(r.data.shiptocountry);
          this.shipment.fromCountry = this.capitalizeWords(r.data.shipfromcountry);
          this.shipment.toCountry = this.capitalizeWords(r.data.shiptocountry);
          this.hqdataTo = r.data.client?.companyLinked || null;

          this.setSOAddresses(r.data);
          this.getShipmentsBySo();
          
          const incoming = this._shipmentService.consumePendingBulkItems();

          if (incoming && incoming.length) {
            this.loadingShipmentItems = true;
            this.dataFromExternal = true;
            const mapped = this.mapSuperbulkToShipmentItems(incoming);
            this.shipmentItems = [...mapped, ...this.shipmentItems];
            this.redrawDataTable();
            this.loadingShipmentItems = false;
          } else {
            this.getItemsAvailableToShip();
          }

          this.getCountries();

        }


        this.clickOnNew();
      }
      
    });
      
    }
    this.getCountries();
     //this.titleServices.setTitle( 'Shipment Scheduler' );

      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
          
          } else if (response.status === "success") {
            this.userLogged = response.data;
            this.hqdata = response.data.companyLinked;
            console.log("this.userLogged => ", this.userLogged);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );

      this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        this.userLocations = response.data;
      });


      if(this.idShipmentExternal){
        this.getShipment(this.idShipmentExternal);
      }
  }

/*
  private buildUnifiedCarriers() {
  //if (!this._gotInternalCarriers || !this._gotExternalCarriers) return;
  if (!this._gotInternalCarriers) return;

  const unified: typeof this.carriersUnified = [];

  // 1) INTERNOS (carrierList)
  for (const c of (this.carrierList || [])) {
    let services: Array<{ id: string; name: string }> = [];
    try {
      const parsed = c.serviceType ? JSON.parse(c.serviceType) : [];
      services = (parsed || []).map((s: any) => ({
        id: `int:${c.id}:${s.id}`,     // id estable para el select
        name: s.serviceName?.toString() || ''
      }));
    } catch {
      services = [];
    }

    unified.push({
      id: `int:${c.id}`,
      name: c.name?.toString() || `Carrier ${c.id}`,
      type: c.type?.toString() || 'Internal',
      source: 'internal',
      raw: c,
      services
    });
  }

  // 2) EXTERNOS (carrierListExternal)
  console.log("this.carrierListExternal => ", this.carrierListExternal);
  const ext: any[] = Array.isArray((this as any).carrierListExternal?.carriers)
    ? (this as any).carrierListExternal.carriers
    : (Array.isArray(this.carrierListExternal) ? this.carrierListExternal : []);
    console.log("ext => ", ext);
  for (const c of ext) {
    const services = (c.services || []).map((s: any) => ({
      id: `ext:${c.carrier_id}:${s.service_code}`, // id estable
      code: s.service_code,
      name: s.name?.toString() || s.service_code
    }));

    unified.push({
      id: `ext:${c.carrier_id}`,
      name: (c.friendly_name || c.nickname || c.carrier_code || 'External') + ' (ShipEngine)',
      type: c.carrier_code || 'external',
      source: 'external',
      raw: c,
      services
    });
  }

  console.log("unified => ", unified);

  this.carriersUnified = unified.sort((a, b) => a.name.localeCompare(b.name));
}

*/


private buildUnifiedCarriers() {
  const unified: Array<{
    id: string;               // 'int:38' | 'ext:se-6566571'
    name: string;             // visible en el select
    type: string;             // p.ej. 'Generic' | 'EXTERNAL' | 'fedex'
    source: 'internal' | 'external';
    raw?: any;
    services: Array<{ id: string; code?: string; name: string }>;
  }> = [];

  const list = this.carrierList || [];

  for (const c of list) {
    const external = this.isExternalCarrier(c);

    // ---- Nombre visible y tipo ----
    const displayName = external
      ? (c.externalFrendlyName || c.name || c.externalNickname || c.externalCarrierCode || 'External Carrier')
      : (c.name || `Carrier ${c.id}`);

    const normalizedType = external
      ? (c.externalCarrierCode || c.type || 'EXTERNAL')
      : (c.type || 'Internal');

    // ---- Services: pueden venir en distintos formatos en serviceType ----
    const rawServices = this.safeParse<any[]>(c.serviceType, []);

    let services: Array<{ id: string; code?: string; name: string }> = [];

    if (external) {
      // ShipEngine-like: [{ service_code, name, ... }]
      services = (rawServices || []).map((s: any) => ({
        id: `ext:${c.externalCarrierId || c.id}:${s.service_code || s.code || s.name}`,
        code: s.service_code || s.code || undefined,
        name: s.name?.toString() || s.service_code || 'Service'
      }));
    } else {
      // Interno: [{ id, serviceName, defaultService }]
      services = (rawServices || [])
        .filter((s: any) => s && (s.serviceName || s.name || s.id !== undefined))
        .map((s: any) => ({
          id: `int:${c.id}:${String(s.id ?? s.serviceName ?? s.name)}`,
          name: (s.serviceName ?? s.name ?? '').toString()
        }));
    }

    // ---- Push normalizado ----
    unified.push({
     // id: external ? `ext:${c.externalCarrierId || c.id}` : `int:${c.id}`,
     id: `${c.id}`,
      name: external ? `${displayName}` : displayName,
      type: normalizedType,
      source: external ? 'external' : 'internal',
      raw: c,
      services
    });
  }

  // Orden alfabético
  this.carriersUnified = unified.sort((a, b) => a.name.localeCompare(b.name));
}

  public loadingCountries: boolean = false;
  getCountries() {
    this.loadingCountries = true;
    this._taxService.getCountries().subscribe((r) => {
      console.log("getCountries r =>", r);
      this.countries = r.data;
      this.getStates(this.shipment.fromCountry);
      this.getStates2(this.shipment.toCountry);
      this.loadingCountries = false;
    });
  }

  public statesfrom: any[] = [];
  public statesto: any[] = [];
  getStates(event) {

    this.loadingStates = true;
    this.states = [];
    let country_id = this.countries.find(row => row.name == event)?.id;
    
    if(!country_id) return false;
    this._stateService.listByCountry(country_id, this.token).subscribe(
      r => {
        this.statesfrom = r.data;
       
        this.loadingStates = false;
      }, errror => {
        this.loadingStates = false;
      }
    );
  }

  getStates2(event) {
    this.loadingStates2 = true;
    this.states2 = [];
    let country_id = this.countries.find(row => row.name == event)?.id;

    if(!country_id) return false;
    this._stateService.listByCountry(country_id, this.token).subscribe(
      r => {
        this.statesto = r.data;
        this.loadingStates2 = false;
      }, errror => {
        this.loadingStates2 = false;
      }
    );
  }

  getShipmentsBySo(resetPage: boolean = false) {
    if (!this.soId) return;

    if (resetPage) this.shipmentsPage = 1;

    this.latestShipmentsRequestId++;
    const currentRequestId = this.latestShipmentsRequestId;

    this.loadingShipments = true;

    const token = JSON.parse(localStorage.getItem("token"));
    const filtro = { showvoid: 0 };

    this._shipmentService.listbypov1(
      token,
      this.soId,
      filtro,
      this.shipmentsPage,
      this.shipmentsPerPage,
      this.filtros,
      this.shipmentsSortColumn,
      this.shipmentsSortState
    ).subscribe({
      next: (r: any) => {
        if (currentRequestId !== this.latestShipmentsRequestId) return;

        const rows = Array.isArray(r?.data) ? r.data : [];

        this.shipmentsPage = Number(r?.page_actual) || this.shipmentsPage;
        this.shipmentsPerPage = String(r?.items_per_page ?? this.shipmentsPerPage);
        this.shipmentsTotalItemsCount =
          r?.total_items_count !== undefined ? Number(r.total_items_count) : rows.length;
        this.shipmentsTotalPages =
          r?.total_pages !== undefined
            ? Number(r.total_pages)
            : Math.max(1, Math.ceil(this.shipmentsTotalItemsCount / Number(this.shipmentsPerPage || 10)));

        this.buildShipmentsRows(rows);
        this.loadingShipments = false;
      },
      error: () => {
        if (currentRequestId === this.latestShipmentsRequestId) {
          this.buildShipmentsRows([]);
          this.loadingShipments = false;
        }
      }
    });
  }
  private buildShipmentsRows(data: any[]) {
    const headers = [...this.shipmentsScheduler.headers];
    const rows = [];

    for (let element of (Array.isArray(data) ? data : [])) {

      let actionButtons = [];

      if (element.status != 'Voided' && element.status != 'completed' && element.status != 'Shipped') {
        actionButtons.push({
          icon: "delete_outline",
          action: "delete",
          color: "danger",
          value: element.id,
        });
      }

      let formattedDate = "";
      if (element.createdAt) {
        const [datePart] = element.createdAt.split(" ");
        const [year, month, day] = datePart.split("-");
        formattedDate = `${parseInt(month)}-${parseInt(day)}-${year}`;
      }

      let formattedShipDate = "";
      if (element.shipDate) {
        const [datePart] = element.shipDate.split(" ");
        const [year, month, day] = datePart.split("-");
        formattedShipDate = `${parseInt(month)}-${parseInt(day)}-${year}`;
      }

      rows.push([
        new Cell(element.id),
        new Cell(element.trackingNumber),
        new Cell(element.carrierString),
        new Cell(element.serviceString),
        new Cell(formattedDate),
        new Cell(element.shipped ?? ''),
        new Cell(formattedShipDate),
        new Cell(element.status),
        new Cell(element.fromCompany),
        new Cell(element.toCompany),
        new Cell(actionButtons, { type: "actions", class: "white-space-nowrap" }),
      ]);
    }

    this.shipmentsScheduler = new DinamicData(headers, rows);
  }

  onShipmentsBuscar(e: any) {
    this.shipmentsPage = e?.page || 1;
    this.shipmentsPerPage = e?.perPage || this.shipmentsPerPage;
    this.getShipmentsBySo();
  }

  handleShipmentsRightClick(data: any): void {
    const columnKey = data?.columnName?.key;
    if (!columnKey) return;

    if (columnKey === this.shipmentsSortColumn) {
      this.shipmentsSortState = this.shipmentsSortState === 'DESC' ? 'ASC' : 'DESC';
    } else {
      this.shipmentsSortState = 'ASC';
    }

    this.shipmentsSortColumn = columnKey;
    this.shipmentsPage = 1;
    this.getShipmentsBySo();
  }

  private resetShipmentsFiltros() {
    this.shipmentsPage = 1;
    this.shipmentsSortColumn = '';
    this.shipmentsSortState = '';
    for (const f of this.filtros) {
      if (f) f.value = '';
    }
  }
  setSOAddresses(data, full = true){

  

    this.shipment.fromCompany = data.shipfromcompany;
    this.shipment.fromAddress = data.shipfromaddress1;
    this.shipment.fromAddress2 = data.shipfromaddress2;
    this.shipment.fromCity = data.shipfromcity;
    this.shipment.fromName = data.shipfromcontact;
    this.shipment.fromPhone = data.shipfromphone;
    this.shipment.fromZip = data.shipfrompostalcode;
    this.shipment.fromState = data.shipfromstate;

    this.shipment.toCompany = data.shiptocompany;
    this.shipment.toAddress = data.shiptoaddress1;
    this.shipment.toAddress2 = data.shiptoaddress2;
    this.shipment.toCity = data.shiptocity;
    this.shipment.toName = data.shiptocontact;
    this.shipment.toPhone = data.shiptophone;
    this.shipment.toZip = data.shiptopostalcode;
    this.shipment.toState = data.shiptostate;
    if(full){
      this.clientCompanyId = data.client?.companyLinked?.id;
      this.repCompanyId = data.rep?.companyLinked?.id;
    }
   
    if(data.shipToLocationId == -1){
      this.shipment.shiptolocation_id = "other";
    }
    else if(!data.shipToLocationId || data.shipToLocationId == null){
      this.shipment.shiptolocation_id = "headq";
    }
    this.shipment.serviceString = data.serviceString;


  }

  oneTimeFrom(){
    this.shipment.fromCompany = "";
    this.shipment.fromAddress = "";
    this.shipment.fromAddress2 = "";
    this.shipment.fromCity = "";
    this.shipment.fromName = "";
    this.shipment.fromPhone = "";
    this.shipment.fromZip = "";
    this.shipment.fromState = "";
    this.shipment.shipfromlocation_id = "other";
  }

  oneTimeTo(){

    this.shipment.toCompany = "";
    this.shipment.toAddress = "";
    this.shipment.toAddress2 = "";
    this.shipment.toCity = "";
    this.shipment.toName = "";
    this.shipment.toPhone = "";
    this.shipment.toZip = "";
    this.shipment.toState = "";
    this.shipment.shiptolocation_id = "other";
  }

  capitalizeWords(str: string): string {
    return String(str || '')
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }


  selectLocationTo(newLocationId: any) {
    console.log("this.locations => ", this.locations);
     this.shipment.shiptolocation_id = newLocationId;

    if (
      this.shipment.shiptolocation_id !== "new" &&
      this.shipment.shiptolocation_id !== "other" &&
      this.shipment.shiptolocation_id !== "headq"
    ) {
      for (let location of this.locations) {

        if (this.shipment.shiptolocation_id == location.id) {

          this._contactsService.listByCompany(this.shipment.shiptolocation_id).subscribe(
        r => {
          this.contactsShippingFrom = r.data;


        },
        error => {
          console.error("Error getting contacts", error);
        }
      );

          this.shipment.toCountry = location.country;
          this.shipment.toCompany = location.companyLinked.name;
          this.shipment.toAddress = location.address;
          this.shipment.toAddress2 = location.address2;
          this.shipment.toCity = location.city;
          let tmpState = location.colonia.split(' ')[0];
          this.shipment.toZip = location.zipCode;
          tmpState = tmpState.trim();
          console.log("tmpState => ", tmpState);
          this.getStatesAfterSelectingColonia(tmpState, "shiptostate");
          break;
        }
      }
    } else if (this.shipment.shiptolocation_id == "headq") {
      this.shipment.toCompany = this.hqdataTo.name;
      //this.shipment.toName = this.hqdataTo.contactcontact;
      this.shipment.toEmail = this.hqdataTo.email;
      this.shipment.toFax = this.hqdataTo.fax;
      this.shipment.toPhone = this.hqdataTo.phone;
      this.shipment.toAddress = this.hqdataTo.address;
      this.shipment.toAddress2 = this.hqdataTo.address2;
      this.shipment.toCity = this.hqdataTo.city;
      this.shipment.toState = this.hqdataTo.colonia.split(' ')[0];
      console.log("this.shipment.toState => ", this.shipment.toState);
      this.shipment.toCountry = this.capitalizeWords(this.hqdataTo.country);
      this.shiptocountry = this.capitalizeWords(this.hqdataTo.country);
      this.shipment.toZip = this.hqdataTo.zipCode;
      this.getStatesAfterSelectingColonia(this.shipment.toState, "shiptostate");
    } else if (this.shipment.shiptolocation_id == "other"){
      this.shipment.toName = '';
      //this.shipment.toEmail = '';
      //this.shipment.toFax = '';
      this.shipment.toPhone = '';

   

      this.shipment.toAddress = "";
      this.shipment.toAddress2 = "";
      this.shipment.toCity = "";
      this.shipment.toState = "";
      this.shipment.toCountry = "";
      this.shipment.toZip = "";
      //this.getStates(this.shipment.toCountry);
    }
    //
  }

  selectLocationFrom(newLocationId: any) {
     this.shipment.shipfromlocation_id = newLocationId;

    if (
      this.shipment.shipfromlocation_id !== "new" &&
      this.shipment.shipfromlocation_id !== "other" &&
      this.shipment.shipfromlocation_id !== "headq"
    ) {
      for (let location of this.userLocations) {

        if (this.shipment.shipfromlocation_id == location.id) {

          this._contactsService.listByCompany(this.shipment.shipfromlocation_id).subscribe(
        r => {
          this.contactsShippingFrom = r.data;


        },
        error => {
          console.error("Error getting contacts", error);
        }
      );

          this.shipment.fromCountry = location.country;
          this.shipment.fromCompany = location.companyLinked.name;
          this.shipment.fromAddress = location.address;
          this.shipment.fromAddress2 = location.address2;
          this.shipment.fromCity = location.city;
          let tmpState = location.colonia.split(' ');
          this.shipment.fromZip = location.zipCode;
          this.getStatesAfterSelectingColonia(location.colonia, "shipfromstate");
          break;
        }
      }
    } else if (this.shipment.shipfromlocation_id == "headq") {
      this.shipment.fromCompany = this.hqdata.name;
      //this.shipment.fromName = this.hqdata.contactcontact;
      this.shipment.fromEmail = this.hqdata.email;
      this.shipment.fromFax = this.hqdata.fax;
      this.shipment.fromPhone = this.hqdata.phone;
      this.shipment.fromAddress = this.hqdata.address;
      this.shipment.fromAddress2 = this.hqdata.address2;
      this.shipment.fromCity = this.hqdata.city;
      this.shipment.fromState = this.hqdata.colonia;
      this.shipment.fromCountry = this.capitalizeWords(this.hqdata.country);
      this.shipfromcountry = this.capitalizeWords(this.hqdata.country);
      this.shipment.fromZip = this.hqdata.zipCode;
      this.getStatesAfterSelectingColonia(this.shipment.fromState, "shipfromstate");
    } else if (this.shipment.shipfromlocation_id == "other"){
      this.shipment.fromName = "";
      //this.shipment.fromEmail = this.userLogged.email;
      //this.shipment.fromFax = this.userLogged.phone;
      this.shipment.fromPhone = "";

      if(!this.userLogged.phone)
        this.shipment.fromPhone = this.userLogged.mobilePhone;

      this.shipment.fromAddress = "";
      this.shipment.fromAddress2 = "";
      this.shipment.fromCity = "";
      this.shipment.fromState = "";
      this.shipment.fromCountry = "";
      this.shipment.fromZip = "";
      //this.getStates(this.shipment.fromCountry);
    }
    //
  }

getStatesAfterSelectingColonia(colonia: string, destiny: string) {
  console.log("this.shipment.toCountry => ", this.shipment.toCountry);
  let country_id: any = null;

  if(destiny == "shipfromstate"){
         country_id = this.countries.find(row => row.name == this.shipment.fromCountry)?.id;
          this.loadingStates = true;
      } else if(destiny == "shiptostate"){
        this.loadingStates2 = true;
         country_id = this.countries.find(row => row.name == this.shipment.toCountry)?.id;
        
      }

    this._stateService.listByCountry(country_id, this.token).subscribe(
    r => {
      if(destiny == "shipfromstate"){
        this.statesfrom = r.data;
      } else if(destiny == "shiptostate"){
        this.statesto =r.data;
      }

        setTimeout(() => {
       
      const abbr = this.getStateAbbrFromNameOrColonia(colonia, destiny);

      if (destiny === "shipfromstate") {
        this.shipment.fromState = abbr;
      } else if (destiny === "shiptostate") {
        this.shipment.toState = abbr;
      }

      this.loadingStates = false;
      this.loadingStates2 = false;
    }, 3000); 

     // this.loadingStates = false;
    },
    error => {
      this.loadingStates = false;
      this.loadingStates2 = false;
    });


}

showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

saveShipment(){

  this.saveLoading = true;
  this.shipment.items = this.shipmentItems;
  this.shipment.so_id = this.soId;
  //this.shipment.serviceString = encodeURIComponent(this.shipment.serviceString);


  if(this.shipment.id){

    this._shipmentService.edit(this.token,this.shipment.id, this.shipment).subscribe((response) => {

    if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "error") {
          this.mtds.notifyError(response.msg);
          
        } else if (response.status == "success") {

          this.showToast(
              "success",
              "Shipment has been updated successfully",
              2000
            );
           this.getShipmentsBySo();
        }

        this.saveLoading = false;

  });

  } else {

    /*if (this.shipment.dateShipment < this.minDate) {
      alert('Please select today or a future date.');
      this.saveLoading = false;
      return;
    }*/

  this._shipmentService.createfromzero(this.token,this.shipment).subscribe((response) => {

    if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "error") {
          this.mtds.notifyError(response.msg);
          
        } else if (response.status == "success") {
          this.getShipment(response.data.id);
          this.showToast(
              "success",
              "Shipment has been created successfully",
              2000
            );
           this.getShipmentsBySo();
        }

        this.saveLoading = false;

  });

  }

  
}

getStateAbbrFromNameOrColonia(colonia: string, destiny: string): string {
   
  // Intenta extraer la abreviatura desde el campo 'colonia' o nombre completo
  const clean = colonia?.trim().split('-')[0].trim(); // si viene como "TX - Texas"
  let  match:any = null;
  if(destiny == 'shipfromstate'){
    match = this.statesfrom.find(s => s.abbr === clean || s.name === clean);
  }
  else if(destiny == 'shiptostate'){
    match = this.statesto.find(s => s.abbr === clean || s.name === clean);
  }

  return match ? match.abbr : '';
}

clickOnNew(){
  this.searchso = this.soNumber;
  this.searchingSO();
  this.shownewshipmentform = true;

  this.shipment.warehouse = this.userLogged.location?.id;
  this.shipment.unitOfMeasurement = this.userLogged.companyLinked?.weightUnit;
  this.shipment.unitDimension = this.userLogged.companyLinked?.dimensionUnit;
  this.shipment.signature = 'No Signature';
  this.shipment.billAccountNumber = "";
  this.manualBillAccountNumber = "";
}

clickOnProcess(){
  if(this.shipment.id){
    this._router.navigate([`/shipments/process/${this.shipment.id}`]);
  } else {
    alert("Please select a shipment");
  }
}

clickOnCancelShip(){

    this.shownewshipmentform = false;
    this.shipment.id = null;
    this.shipmentSelected = false;
    this.shipment.carrier = null;
    this.shipment.serviceType = null;
    this.shipment.paymentType = null;
    this.shipment.billAccountNumber = null;
    this.shipment.addFreightInvoice = false;
    this.shipment.cod = "";
    this.shipment.declaredValue = "";
    this.shipment.warehouse = null;
    this.shipment.unitOfMeasurement = "";
    this.shipment.email = "";
    this.shipment.signature = null;
    this.shipment.fromCompany = "";
    this.shipment.fromName = "";
    this.shipment.fromPhone = "";
    this.shipment.fromAddress = "";
    this.shipment.fromAddress2 = "";
    this.shipment.fromCity = "";
    this.shipment.fromState = "";
    this.shipment.fromZip = "";
    this.shipment.fromCountry = "";
    this.shipment.fromEmail = "";
    this.shipment.fromFax = "";
    this.shipment.toCompany = "";
    this.shipment.toName = "";
    this.shipment.toPhone = "";
    this.shipment.toAddress = "";
    this.shipment.toAddress2 = "";
    this.shipment.toCity = "";
    this.shipment.toState = "";
    this.shipment.toZip = "";
    this.shipment.toCountry = "";
    this.shipment.toEmail = "";
    this.shipment.toFax = "";
    this.shipment.shipfromlocation_id= null;
    this.shipment.shiptolocation_id= null;
    this.shipment.items= [];
    this.shipment.status= 'Scheduled';
    this.shipment.type= 'MANUAL';
    this.shipment.blindDropShipWayBill = false;
    this.shipment.saturdayDelivery = false;
    this.shipment.residentDelivery = false;



  this.shipment.notifications.exception = false;
  this.shipment.notifications.delivery = false;
  this.shipment.notifications.shipment = false;
  this.shipment.notifications.shipTo = false;
   

}

public showSONotFound: boolean = false

  searchingSO(){
    this.showSONotFound = false;
    this.selectedIds.clear();
    this.resetShipmentsFiltros();
    if(!this.dataFromExternal){
      this.loadingShipmentItems = true;
      this.shipmentItems = [];
    }
    this.clickOnCancelShip();


    this._saleService.getOneSOBySO(this.searchso).subscribe((r) => {
      console.log("getOneSOBySO r => ", r.data);

      if(r.status == 'success'){
        if(r.data && r.data.id){
          this.soId = r.data.id;
          this.soNumber = r.data.so;

          this.titleServices.setBreadcrumbs([
            { label: `SO# ${this.soNumber}`, path: "/sales-orders/"+ this.soId},
            { label: "Shipment Scheduler", path: "/shipment-scheduler" }
          ]);

          if(r.data.shipFromLocationId == -1)
            this.shipment.shipfromlocation_id ="other";
          else if(r.data.shipFromLocationId == 0)
            this.shipment.shipfromlocation_id ="headq";
          else
            this.shipment.shipfromlocation_id = r.data.shipFromLocationId;

          if(r.data.shipToLocationId == -1)
            this.shipment.shiptolocation_id ="other";
          else if(r.data.shipToLocationId == 0)
            this.shipment.shiptolocation_id ="header";
          else
            this.shipment.shiptolocation_id = r.data.shipToLocationId;

          this.shipfromcountry = this.capitalizeWords(r.data.shipfromcountry);
          this.shiptocountry = this.capitalizeWords(r.data.shiptocountry);
          this.shipment.fromCountry = this.capitalizeWords(r.data.shipfromcountry);
          this.shipment.toCountry = this.capitalizeWords(r.data.shiptocountry);

          this.hqdataTo = r.data.client?.companyLinked || null;

          if(r.data && r.data.contactcontactuser && r.data.contactcontactuser.id)
          this._locationService
             .getLocationsByUser(this.token, r.data.contactcontactuser.id)
              .subscribe((response2) => {
               this.locations = response2.data;
             });

          this.setSOAddresses(r.data);

          this.getShipmentsBySo();
          if(!this.dataFromExternal)
            this.getItemsAvailableToShip();
          

          this.getCountries();
        }
      } else if(r.status == 'error' && r.msg == 'SoInfo not found') {

        this.showSONotFound = true;
        this.shipmentsTotalItemsCount = 0;
        this.shipmentsTotalPages = 1;
        this.shipmentsPage = 1;
        this.buildShipmentsRows([]);
        
      } else if(r.status == 'error' && r.msg == 'Authorization not valid') {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
      }

    
        this.dataFromExternal = false;

      
    });

    //this.soId = this.searchso;
    
  }

  public loadingShipment: boolean = false;
  public paymentTypeLoading: boolean = false;
  public billAccountLoading: boolean = false;
  getShipment(id){
    this.selectedIds.clear();
    let me = this;
    this.paymentTypeLoading = true;
    this.serviceTypeLoading = true;
    this.billAccountLoading = true;
    this.shipmentSelected = true;
    this.loadingShipment = true;
    this._shipmentService.detail(this.token, id).subscribe((r) => {
      console.log("shipment detail r => ", r);

      if(r.status == "success"){
        this.soId = r.data.so.id;
        this.soNumber = r.data.so.so;
        this.shipment.id = r.data.id;
        this.setSOAddresses(r.data, false);
        this.shipment.dateShipment = new Date(r.data.createdAt);
        
        this.shipment.carrier = r.data.carrier?.id;
        this.selectCarrier(this.shipment.carrier, false);

        this.shipment.serviceType = r.data.serviceCode;
        this.shipment.paymentType = r.data.paymentType;

        this.shipment.unitDimension = r.data.unitDimension;
        
        this.billAccountNumberList.push({ id: r.data.billAccountNumber, name: r.data.billAccountNumber });
        let paymentFromList = this.paymentList.find(value => this.shipment.paymentType == value.name)
        
        if(paymentFromList && paymentFromList.id) this.shipment.paymentType = paymentFromList.id
        
        this.shipment.addFreightInvoice = r.data.addFreight === 1;

    

        if(r.data.shipfromlocationId == -1)
          this.shipment.shipfromlocation_id ="other";
        else if(r.data.shipfromlocationId == 0)
          this.shipment.shipfromlocation_id ="headq";
        else
          this.shipment.shipfromlocation_id = r.data.shipfromlocationId;

       
        if(r.data.shiptolocationId == -1)
          this.shipment.shiptolocation_id ="other";
        else if(r.data.shiptolocationId == 0)
          this.shipment.shiptolocation_id ="headq";
        else
          this.shipment.shiptolocation_id = r.data.shiptolocationId;

      
        

        this.shipment.declaredValue = r.data.declaredValue;
        this.shipment.warehouse = r.data.warehouse?.id;
        this.shipment.unitOfMeasurement = r.data.unitMeasurement;
        this.shipment.email = r.data.email;
        this.shipment.signature = r.data.signature;
        this.shipment.fromCompany = r.data.fromCompany;
        this.shipment.fromName = r.data.fromName;
        this.shipment.fromPhone = r.data.fromPhone;
        this.shipment.fromAddress = r.data.fromAddress;
        this.shipment.fromAddress2 = r.data.fromAddress2;
        this.shipment.fromCity = r.data.fromCity;
        this.shipment.fromState = r.data.fromState;
        this.shipment.fromZip = r.data.fromPostalcode;
        this.shipment.fromCountry = r.data.fromCountry;
        //this.shipment.fromEmail = "";
        //this.shipment.fromFax = "";
        this.shipment.toCompany = r.data.toCompany;
        this.shipment.toName = r.data.toName;
        this.shipment.toPhone = r.data.toPhone;
        this.shipment.toAddress = r.data.toAddress;
        this.shipment.toAddress2 = r.data.toAddress2;
        this.shipment.toCity = r.data.toCity;
        this.shipment.toState = r.data.toState;
        this.shipment.toZip = r.data.toPostalcode;
        this.shipment.toCountry = r.data.toCountry;
        //this.shipment.toEmail = "";
        //this.shipment.toFax = "";
        //this.shipment.shipfromlocation_id= null;
        //this.shipment.shiptolocation_id= null;

        //getting bill account number
        let paymentId = 1; //sender
        let companyCarrier = '';
        let paymentType_exploded = this.shipment.paymentType.split(":");

        paymentId = paymentType_exploded[2] ? paymentType_exploded[2] : 1;

        if(Number(paymentId) === 1){
          //Sender
          this.isSender = true;
          companyCarrier = this.repCompanyId;
        } else if(Number(paymentId) === 2 || Number(paymentId) === 3) {
         
          // Recipient o ThirdParty
          companyCarrier = this.clientCompanyId;
        }

        let externalCarrierId = this.shipment.carrier;
         


          let filtro = [
                {
                  key: "filterbycarrierid",
                  value: externalCarrierId,
                }
              ]

          this._carrieraccountService.listbycompany(companyCarrier, 1, 1, filtro).subscribe(
          r => {

            console.log("carrierAccount Linked => r", r);
            if (r.status == 'success' && r.data && r.data.length > 0) {
              const accountNumber = r.data[0].billAccountNumber;

              if (!this.billAccountNumberList.some(opt => opt.id === accountNumber)) {
                this.billAccountNumberList.push({ id: accountNumber, name: accountNumber });
              }

              
            
            }

          }, errror => {
          
          }
        );

        this.shipment.items= [];
        this.shipmentItems = [];
        this.loadingShipmentItems = true;
        this.shipmentItems = r.inventories.map((x: any) => ({
        id: x.id,
        soline: x.soline,
        item: x.item,
        manufacturer: x.manufacturer,
        serialNumber: x.serialnumber,
        description: x.description,
        status: x.status?.trim(),
        receivestatus: x.receivestatus?.trim(),
        shipdate: x.shipdate ? new Date(x.shipdate) : null,
        shipstatus: (x.shipstatus || '').trim(),
      }));

        console.log("this.shipmentItems => ", this.shipmentItems);
        
        setTimeout(function(){
          me.redrawDataTable();
          me.loadingShipmentItems = false;
        },2000);
        
      
        this.shipment.billAccountNumber = r.data.billAccountNumber;
        this.billAccountNumberSelection = r.data.billAccountNumber;
        this.shipment.status= r.data.status;
        this.shipment.type= r.data.type;
        this.shipment.blindDropShipWayBill = r.data.blindDropshipWayBill === 1;
        this.shipment.saturdayDelivery = r.data.saturdayDelivery === 1;
        this.shipment.residentDelivery = r.data.residentialDelivery === 1;
        this.shipment.notifications.exception = r.data.notificationException === 1;
        this.shipment.notifications.delivery = r.data.notificationDelivery === 1;
        this.shipment.notifications.shipment = r.data.notificationShipment === 1;
        this.shipment.notifications.shipTo = r.data.notificationShipToNotification === 1;


        


         setTimeout(function(){
          this.serviceTypeLoading = false;
          this.paymentTypeLoading = false;
          this.billAccountLoading = false;
        },2000);
        
        this.loadingStates = false;
        this.loadingStates2 = false;
      } else {
          alert("Error something happens");
        }
      this.shownewshipmentform = true;
      this.loadingShipment = false;
    });

  }

  private mapSuperbulkToShipmentItems(items: any[]): any[] {
  if (!Array.isArray(items)) return [];
  console.log("mapSuperbulkToShipmentItems items => ", items);

  return items
    .filter(x => {
      const shipstatus = String(x.shipstatus || '')
        .trim()
        .toLowerCase();

      return shipstatus === 'open' || shipstatus === '';
    })

    // 2️⃣ Mapear al formato shipmentItem
    .map((x: any) => ({
      id: x.id,
      soline: x.line ?? x.soline ?? null,
      item: x.item || '',
      manufacturer: x.manufacturer || x.brand || '',
      serialNumber: x.serialNumber || '',
      description: x.description || '',
      status: (x.status || '').trim(),
      receivestatus: (x.receivestatus || '').trim(),
      shipdate: x.shipdate || null,
      shipstatus: (x.shipstatus || '').trim(),
      type: x.type || '',
      nonInventory: x.nonInventory || false
    }));
}


  getItemsAvailableToShip() {
    if(this.dataFromExternal) return false;
    this.shipmentItems = [];
    this._saleService.availableToShip(this.soId, '').subscribe((r) => {
      const rows = Array.isArray(r?.lineDesglosado) ? r.lineDesglosado : [];
      console.log("getItemsAvailableToShip => rows", rows);
      // Guardamos las filas
      this.shipmentItems = rows.map((x: any) => ({
        id: x.id,
        soline: x.soline,
        item: x.item,
        manufacturer: x.manufacturer,
        serialNumber: x.serialNumber,
        description: x.description,
        status: x.status?.trim(),
        receivestatus: x.receivestatus?.trim(),
        shipdate: x.shipdate ? new Date(x.shipdate) : null,
        shipstatus: (x.shipstatus || '').trim(),
      }));

      // Reinicializa DataTable con la nueva data
      this.redrawDataTable();
      this.loadingShipmentItems = false;

    });
  }

public serviceTypeLoading: boolean = false;

selectCarrier(selectedId: string, reset = true) {
  this.serviceTypeLoading = true;
  console.log("selectCarrier fired selectedId => ", selectedId);
  console.log("selectCarrier fired reset => ", reset);
  // Reset

  if(reset){
    this.shipment.serviceType = null;
    this.serviceList = [];
    this.shipment.paymentType = null;
    this.paymentList = [];
  }
  

  this.billAccountNumberList = [{ id: 'manual', name: 'Enter manually' }];
  this.billAccountNumberSelection = 'manual';
  this.manualBillAccountNumber = '';
  this.shipment.billAccountNumber = 'manual';

  const carrier = this.carriersUnified.find(c => Number(c.id) === Number(selectedId));
  if (!carrier) return;

  // --- Services ---
  this.serviceList = carrier.services.map(s => ({
    id: s.code ? s.code : s.id,
    name: s.name
  }));

  // --- Payments (interno o externo) ---
  // paymentType puede venir como JSON string o ya objeto/array.
  const paymentsRaw = this.safeParse<any[]>(carrier.raw?.paymentType, []);
  this.paymentList = (paymentsRaw || [])
    .filter((p: any) => p && (p.paymentName || p.name || p.id !== undefined))
    .map((p: any) => {
      let label = (p.paymentName ?? p.name ?? '').toString();
      if(label == 'ThirdParty') label = "Third Party";
      let pidVal = p.id ?? p.categoryName ?? label;
      if (!pidVal) pidVal = 'pay';
      const pid = String(pidVal);

      const pref = carrier.source === 'internal' ? 'intpay' : 'extpay';
      // id compuesto para no colisionar
      return { id: `${pref}:${carrier.raw?.id}:${pid}`, name: label };
    });

    console.log("this.paymentList => ", this.paymentList);

  // Selección automática del defaultPayment si existe (aplica a ambos)
  const defaultPay = (paymentsRaw || []).find((p: any) => p?.defaultPayment === 1);
  if (defaultPay) {
    const pid = String(defaultPay.id ?? defaultPay.categoryName ?? (defaultPay.paymentName ?? defaultPay.name) ?? 'pay');
    const pref = carrier.source === 'internal' ? 'intpay' : 'extpay';
    this.shipment.paymentType = `${pref}:${carrier.raw?.id}:${pid}`;
  }

 this.serviceTypeLoading = false;
}



  selectService(event){
    console.log("selectService event => ", event);
    let serv = this.serviceList.find(value => value.id === event);
    console.log(serv);
    if(serv && serv.name)
    this.shipment.serviceString = serv.name;
  }

  private parseCarrierComposite(val: string | null | undefined): { kind: 'ext' | 'int' | null; id: string } {
  if (!val) return { kind: null, id: '' };
  const [kind, id] = String(val).split(':');
  if (kind === 'ext' || kind === 'int') {
    return { kind, id: id ?? '' };
  }
  return { kind: null, id: '' };
}

public isSender: boolean = false;
  selectPayment(event){
    this.billAccountNumberList = [{ id: 'manual', name: 'Enter manually' }];
  
    this.isSender = false;
    //console.log("selectPayment event => ", event);
    const parts = event.split(":");
    const paymentId = Number(parts[2]); 

    this.billAccountNumberSelection = "";
    this.shipment.billAccountNumber = "";

    let companyCarrier = null;
    if(paymentId == 1){
      //Sender
      this.isSender = true;
      companyCarrier = this.repCompanyId;
    } else if(paymentId === 2 || paymentId === 3) {
      this.freightCheckbox.checked = false;
      // Recipient o ThirdParty
      companyCarrier = this.clientCompanyId;
    }

    let externalCarrierId = this.shipment.carrier;
     


      let filtro = [
            {
              key: "filterbycarrierid",
              value: externalCarrierId,
            }
          ]

      this._carrieraccountService.listbycompany(companyCarrier, 1, 1, filtro).subscribe(
      r => {

        console.log("carrierAccount Linked => r", r);
        if (r.status == 'success' && r.data && r.data.length > 0) {
          const accountNumber = r.data[0].billAccountNumber;

          if (!this.billAccountNumberList.some(opt => opt.id === accountNumber)) {
            this.billAccountNumberList.push({ id: accountNumber, name: accountNumber });
          }

          
          this.billAccountNumberSelection = accountNumber;
          this.shipment.billAccountNumber = accountNumber;
        } else if(r.data && r.data.length == 0){
          this.billAccountNumberSelection = "manual";
        }

      }, errror => {
      
      }
    );

  }

  selectBillAccountNumber(val: string) {
    this.billAccountNumberSelection = val;

    if (val === 'manual') {
      // si aún no han escrito, deja vacío (o conserva lo que ya haya)
      this.shipment.billAccountNumber = this.manualBillAccountNumber || '';
    } else {
      // seleccionaron una cuenta concreta de la lista
      this.shipment.billAccountNumber = val;
    }
  }


  selectWarehouse(event){
    console.log("selectWarehouse event => ", event);
  }

  selectUnitOfMeasurementList(event){
    console.log("selectUnitOfMeasurementList event => ", event);
  }


  selectUnitDimensionList(event){
    console.log("selectUnitDimensionList event => ", event);
  }

  selectSignature(event){
    console.log("selectSignature event => ", event);
  }

  selectFromCompany(event){
    console.log("selectFromCompany event => ", event);
  }

  selectFromPhone(event){
    console.log("selectFromPhone event => ", event);
  }

  selectFromCity(event){
    console.log("selectFromCity event => ", event);
  }

  selectFromState(event){
    console.log("selectFromState event => ", event);
  }

  selectFromZip(event){
    console.log("selectFromZip event => ", event);
  }

  selectFromCountry(event){
    console.log("selectFromCountry event => ", event);
  }

  selectToCompany(event){
    console.log("selectToCompany event => ", event);
  }

  selectToPhone(event){
    console.log("selectToPhone event => ", event);
  }

  selectToCity(event){
    console.log("selectToCity event => ", event);
  }

  selectToState(event){
    console.log("selectToState event => ", event);
  }

  selectToZip(event){
    console.log("selectToZip event => ", event);
  }

  selectToCountry(event){
    console.log("selectToCountry event => ", event);
  }

  onFreightInvoiceChange(event: MatCheckboxChange) {
    console.log("onFreightInvoiceChange is checked => ", event.checked);
    this.shipment.addFreightInvoice = event.checked;
  }


  onBlindDropShipWayBill(event: MatCheckboxChange) {
  this.shipment.blindDropShipWayBill = event.checked;

  if (event.checked) {
    swal.fire({
      title: 'Verify Ship From and Ship To',
      html: `
        <div style="text-align: left; font-size: 14px;">
          <p><strong>Verify Ship From and Ship To:</strong></p>

          <ul style="padding-left: 18px;">
            <li><strong>Ship From</strong> will appear on the shipping waybill and packing list as the shipper.</li>
            <li><strong>Ship To</strong> is the final destination that appears on the waybill and packing list.</li>
          </ul>

          <p>
            In a blind or double-blind shipment, this is where you list the last two parties in the sales chain.
            For example, if you sold to <strong>Company A</strong>, who sold to <strong>Company B</strong>, who then sold to 
            <strong>Company C</strong>, you would list <strong>Company B</strong> as the Ship From and 
            <strong>Company C</strong> as the Ship To.
          </p>

          <p><strong>After making your changes, be sure to click Save.</strong></p>
        </div>
      `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then(result => {
      console.log("result => ", result);
      if (!result.isConfirmed) {
        // Si el usuario cancela, se desmarca el checkbox
        this.shipment.blindDropShipWayBill = false;
      }else if(result.isConfirmed){
      
        if (this.tabs) {
          this.tabs.selectedIndex = 1;
          this.oneTimeFrom();
          this.oneTimeTo();

          
        }
      }
    });
  }
}


  onSaturdayDelivery(event: MatCheckboxChange) {
    this.shipment.saturdayDelivery = event.checked;
  }

  onResidentDelivery(event: MatCheckboxChange) {
    this.shipment.residentDelivery = event.checked;
  }


  selectEmail(event){
    console.log("selectEmail event => ", event);
  }

  toggleCODLock() {
  this.codLocked = !this.codLocked;
}

action(e) {
    console.log(e);

    switch (e.action) {
      case 'show':
        
        this.getShipment(e.id);
        break;
      case 'delete':

        this.voidShipment(e.id);

        break;
      default:
        break;
    }
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig('shipmentsScheduler', this.options).subscribe(
      r => {
        console.log(r);
      }
    );
  }

  ngAfterViewInit() {

    if (this.shipmentItems.length) {
      this.initDataTable();
    }

  }

  ngOnDestroy() {
    this.destroyDataTable();
  }

  removeSelectedItems() {
  if (this.selectedIds.size === 0) {
    swal.fire({
      icon: 'info',
      title: 'No items selected',
      text: 'Please select at least one item to remove.',
      timer: 2000,
      showConfirmButton: false
    });
    return;
  }

  let me = this;

  this.loadingShipmentItems = true;

  swal
    .fire({
      title: 'Remove selected items?',
      text: 'Items will be deleted from the shipment',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    })
    .then(result => {
      console.log("removeSelectedItems ", this.selectedIds);
      if (result.isConfirmed) {
   

        if(this.shipment.id){
          let senddata = { items: Array.from(this.selectedIds) };
          this._shipmentService.removeitems(this.token,senddata, this.shipment.id).subscribe((r) => {
            console.log("removeitems => ", r);
            if(r.status == "success"){
              this.loadingShipmentItems = true;
      
            this._shipmentService.detail(this.token, this.shipment.id).subscribe((r) => {


            if(r.status == "success"){
            
              this.shipment.items= [];
              this.shipmentItems = [];
              
              this.shipmentItems = r.inventories.map((x: any) => ({
              id: x.id,
              soline: x.soline,
              item: x.item,
              manufacturer: x.manufacturer,
              serialNumber: x.serialNumber,
              description: x.description,
              status: x.status?.trim(),
              receivestatus: x.receivestatus?.trim(),
              shipdate: x.shipdate ? new Date(x.shipdate) : null,
              shipstatus: (x.shipstatus || '').trim(),
            }));

         
              
              setTimeout(function(){
                me.redrawDataTable();
                me.loadingShipmentItems = false;
              },2000);



            } 
     
    });
            }
            else if(r.status == "error") alert("Error: " + r?.msg);
          });
        } else {
           // Elimina todos los seleccionados
          this.shipmentItems = this.shipmentItems.filter(
            item => !this.selectedIds.has(item.id)
          );
        }
       

        // Limpia la selección
        this.selectedIds.clear();

        this.loadingShipmentItems = false;

        swal.fire({
          icon: 'success',
          title: 'Removed',
          text: 'Selected items have been removed.',
          timer: 1500,
          showConfirmButton: false
        });
      } else {
        this.loadingShipmentItems = false;
      }
    });
}


  // --- DataTables helpers ---
  private initDataTable() {
    if (this.dtInited) return;

    const $table = $('#shipmentItems');

    // Asegurarnos de que el DOM esté listo
    setTimeout(() => {
      this.dtInstance = $table.DataTable({
        // Layout con toolbars izquierda/derecha
        dom: '<"d-flex justify-content-between align-items-center mb-2"<"dt-left-toolbar"><"dt-right-toolbar"fB>>rtip',
        responsive: true,
        autoWidth: false,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        buttons: [
          { extend: 'excel', title: 'Shipment Items' },
          { extend: 'print', title: 'Shipment Items' },
          { extend: 'colvis', text: 'Columns' }
        ],
        // Orden por defecto (ej: por Línea)
        order: [[1, 'asc']],
        columnDefs: [
          { targets: 0, orderable: false, searchable: false }, // checkbox
          { targets: -1, orderable: false, searchable: false }, // actions
        ]
      });
      this.dtInited = true;
    }, 0);
  }

  private destroyDataTable() {
    if (this.dtInited && this.dtInstance) {
      this.dtInstance.destroy(true);
      this.dtInstance = null;
      this.dtInited = false;
    }
  }

  private redrawDataTable() {
    // destruimos e inicializamos de nuevo para que DataTables coja el nuevo tbody
    this.destroyDataTable();
    this.initDataTable();
  }

  // --- selección de filas ---
  toggleSelectAll(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.shipmentItems.forEach(r => this.selectedIds.add(r.id));
    } else {
      this.selectedIds.clear();
    }
  }

  toggleSelect(id: number, e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) this.selectedIds.add(id);
    else this.selectedIds.delete(id);
  }

  voidShipment(id){

    if(id){

      swal
    .fire({
      title: `Void Shipment #${id}?`,
      text: 'This action is permanent and cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, void this shipment',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    })
    .then(result => {
 
      if (result.isConfirmed) {
   

       this._shipmentService.voidShipment(this.token,id).subscribe((r) => {
           if(r.status == 'success'){
              swal.fire({
                icon: 'success',
                title: 'Voided',
                text: 'Shipment has been voided',
                timer: 1500,
                showConfirmButton: false
              });
              this.searchingSO();
           } else {
            alert("Error: " + r?.msg);
           }
          });

        
      } 
    });


    } else {

      swal
    .fire({
      title: `Void Shipment?`,
      text: 'This action is permanent and cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, void this shipment',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    })
    .then(result => {
 
      if (result.isConfirmed) {
   

       this._router.navigate(["/shipments"]);
        
      } 
    });


    }

    

  }

  // --- Actions ---
  removeItem(row: any) {
    this.loadingShipmentItems = true;
    console.log("row -> ", row);
      if(this.shipment.id){
        let arr = []; arr.push(row.id)
          let senddata = { items: arr };
          this._shipmentService.removeitems(this.token,senddata, this.shipment.id).subscribe((r) => {
            if(r.status == 'error'){ alert("Error: " + r.msg);}
          });
        } 

      this.shipmentItems = this.shipmentItems.filter(x => x.id !== row.id);
      this.selectedIds.delete(row.id);

    //this.redrawDataTable();
    this.loadingShipmentItems = false;
  }

  trackByItemId = (_: number, item: any) => item.id;

}